module.exports = __webpack_public_path__ + "static/media/svg5.6262f21d.svg";